module.exports = __webpack_public_path__ + "img/booths_bg.ffd7f263.png";